var _slicedToArray = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var getAddress = require('ethers').utils.getAddress;

var _require = require('bn.js'),
    BN = _require.BN;

var getBalanceLeaf = require('./Channel').Channel.getBalanceLeaf;

var MerkleTree = require('./MerkleTree');

var BalanceTree = /*#__PURE__*/function () {
  "use strict";

  function BalanceTree(tree) {
    _classCallCheck(this, BalanceTree);

    var entries = Object.entries(tree).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          addr = _ref2[0],
          bal = _ref2[1];

      return [getAddress(addr), new BN(bal, 10)];
    });
    this.balances = Object.fromEntries(entries);
    this.mTree = new MerkleTree(entries.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          addr = _ref4[0],
          bal = _ref4[1];

      return getBalanceLeaf(addr, bal);
    }));
    Object.freeze(this);
  }

  _createClass(BalanceTree, [{
    key: "getProof",
    value: function getProof(addr) {
      return this.mTree.proof(getBalanceLeaf(addr, this.getBalance(addr)));
    }
  }, {
    key: "getBalance",
    value: function getBalance(addr) {
      return this.balances[getAddress(addr)] || new BN(0);
    }
  }]);

  return BalanceTree;
}();

module.exports = BalanceTree;